<div id="list-statements" *ngIf="templateView==1" class="mb-5">
    <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.ACCOUNT_ESTATEMENTS" | translate }}</h2>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.REPORTS" | translate }}</h3>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-3" *ngIf="permissionMenu.VerInformeComisiones == 1">
            <div class="card card-custom card-stretch gutter-b" (click)="clickView(0,2)">
                <div class="card-body d-flex p-0">
                    <div class="flex-grow-1 bg-white p-5 pb-5 card-rounded flex-grow-1 bgi-no-repeat" style="background-position: calc(100% + 0.5rem) bottom;background-size: 35% auto;">
                        <p class="text-center"><i class="fa fa-file-alt icon-5x text-mid-dark"></i></p>
                        <p class="text-dark text-center pt-10 pb-5 font-size-h4 font-weight-bolder line-height-lg">{{ "GENERAL.REPORT_SALESCOMISSION" | translate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-3" *ngIf="permissionMenu.VerInformePagosAplicados == 1">
            <div class="card card-custom card-stretch gutter-b"  (click)="clickView(0,3)">
                <div class="card-body d-flex p-0">
                    <div class="flex-grow-1 bg-white p-5 pb-5 card-rounded flex-grow-1 bgi-no-repeat" style="background-position: calc(100% + 0.5rem) bottom;background-size: 35% auto;">
                        <p class="text-center"><i class="fas fa-money-check-alt icon-5x text-mid-dark"></i></p>
                        <p class="text-dark text-center pt-10 pb-5 font-size-h4 font-weight-bolder line-height-lg">{{ "GENERAL.REPORT_PAYMENTS" | translate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-3" *ngIf="permissionMenu.VerInformeListadoFacturacion == 1">
            <div class="card card-custom card-stretch gutter-b"  (click)="clickView(0,4)">
                <div class="card-body d-flex p-0">
                    <div class="flex-grow-1 bg-white p-5 pb-5 card-rounded flex-grow-1 bgi-no-repeat" style="background-position: calc(100% + 0.5rem) bottom;background-size: 35% auto;">
                        <p class="text-center"><i class="fas fa-money-check-alt icon-5x text-mid-dark"></i></p>
                        <p class="text-dark text-center pt-10 pb-5 font-size-h4 font-weight-bolder line-height-lg">{{ "GENERAL.REPORT_INVOICES" | translate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-3" *ngIf="permissionMenu.VerInformeListadoMorosidad == 1">
            <div class="card card-custom card-stretch gutter-b"  (click)="clickView(0,5)">
                <div class="card-body d-flex p-0">
                    <div class="flex-grow-1 bg-white p-5 pb-5 card-rounded flex-grow-1 bgi-no-repeat" style="background-position: calc(100% + 0.5rem) bottom;background-size: 35% auto;">
                        <p class="text-center"><i class="fas fa-money-check-alt icon-5x text-mid-dark"></i></p>
                        <p class="text-dark text-center pt-10 pb-5 font-size-h4 font-weight-bolder line-height-lg">{{ "GENERAL.REPORT_DELINQUENCY" | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="col-md-3" *ngIf="permissionMenu.VerInformeListadoReclamos == 1">
            <div class="card card-custom card-stretch gutter-b"  (click)="clickView(0,7)">
                <div class="card-body d-flex p-0">
                    <div class="flex-grow-1 bg-white p-5 pb-5 card-rounded flex-grow-1 bgi-no-repeat" style="background-position: calc(100% + 0.5rem) bottom;background-size: 35% auto;">
                        <p class="text-center"><i class="fas fa-money-check-alt icon-5x text-mid-dark"></i></p>
                        <p class="text-dark text-center pt-10 pb-5 font-size-h4 font-weight-bolder line-height-lg">{{ "GENERAL.REPORT_CLAINS" | translate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-3" *ngIf="permissionMenu.VerInformeListadoSolicitudesPendientes == 1">
            <div class="card card-custom card-stretch gutter-b"  (click)="clickView(0,8)">
                <div class="card-body d-flex p-0">
                    <div class="flex-grow-1 bg-white p-5 pb-5 card-rounded flex-grow-1 bgi-no-repeat" style="background-position: calc(100% + 0.5rem) bottom;background-size: 35% auto;">
                        <p class="text-center"><i class="fas fa-money-check-alt icon-5x text-mid-dark"></i></p>
                        <p class="text-dark text-center pt-10 pb-5 font-size-h4 font-weight-bolder line-height-lg">{{ "GENERAL.REPORT_SOLICITUDES" | translate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-3" *ngIf="permissionMenu.VerReportesOtros == 1">
            <div class="card card-custom card-stretch gutter-b"  (click)="clickView(0,9)">
                <div class="card-body d-flex p-0">
                    <div class="flex-grow-1 bg-white p-5 pb-5 card-rounded flex-grow-1 bgi-no-repeat" style="background-position: calc(100% + 0.5rem) bottom;background-size: 35% auto;">
                        <p class="text-center"><i class="fas fa-money-check-alt icon-5x text-mid-dark"></i></p>
                        <p class="text-dark text-center pt-10 pb-5 font-size-h4 font-weight-bolder line-height-lg">{{ "REPORT.REPORT_LIST" | translate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-3" [hidden]="!biM1HTMLShow">
            <div class="card card-custom card-stretch gutter-b" (click)="clickView(0,6)">
                <div class="card-body d-flex p-0">
                    <div class="flex-grow-1 bg-white p-5 pb-5 card-rounded flex-grow-1 bgi-no-repeat" style="background-position: calc(100% + 0.5rem) bottom;background-size: 35% auto;">
                        <p class="text-center"><i class="fa fa-file-alt icon-5x text-mid-dark"></i></p>
                        <p class="text-dark text-center pt-10 pb-5 font-size-h4 font-weight-bolder line-height-lg">{{biM1HTML.NombreReporte}}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>


<div id="report-comisiones" *ngIf="templateView==2">
    <div class="row mt-5">
        <div class="col-md-6 col-sm-12">
            <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.REPORT_SALESCOMISSION" | translate }}</h2>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                </div>
            </div>
        </div>
    </div>
    
    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="form-group row mx-5 my-5  justify-content-md-left">
                <div class="col-md-12">
                    <ng-container
                    [ngTemplateOutlet]="genericFilterForm"
                    [ngTemplateOutletContext]="{
                    control: filterForm,
                    filter: 1,
                    requiredYear: 'required',
                    requiredMonth: 'required',
                    requiredDocument: 'required'
                    }"
                ></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="report-payments" *ngIf="templateView==3">
    <div class="row mt-5">
        <div class="col-md-6 col-sm-12">
            <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.REPORT_PAYMENTS" | translate }}</h2>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                </div>
            </div>
        </div>
    </div>
    
    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="form-group row mx-5 my-5  justify-content-md-left">
                <div class="col-md-12">
                    <ng-container
                        [ngTemplateOutlet]="genericFilterForm"
                        [ngTemplateOutletContext]="{
                        control: filterForm,
                        filter: 2,
                        requiredYear: 'required',
                        requiredMonth: 'required',
                        requiredDocument: 'required'
                        }"
                    ></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="report-invoices" *ngIf="templateView==4">
    <div class="row mt-5">
        <div class="col-md-6 col-sm-12">
            <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.REPORT_INVOICES" | translate }}</h2>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                </div>
            </div>
        </div>
    </div>
    
    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="form-group row mx-5 my-5  justify-content-md-left">
                <div class="col-md-12">
                    <ng-container
                        [ngTemplateOutlet]="genericFilterForm"
                        [ngTemplateOutletContext]="{
                        control: filterForm,
                        filter: 3,
                        requiredYear: 'required',
                        requiredMonth: 'required',
                        requiredDocument: 'required'
                        }"
                    ></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="report-delinquency" *ngIf="templateView==5">
    <div class="row mt-5">
        <div class="col-md-6 col-sm-12">
            <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.REPORT_DELINQUENCY" | translate }}</h2>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                </div>
            </div>
        </div>
    </div>
    
    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="form-group row mx-5 my-5  justify-content-md-left">
                <div class="col-md-12">
                    <ng-container
                        [ngTemplateOutlet]="genericFilterForm"
                        [ngTemplateOutletContext]="{
                        control: filterForm,
                        filter: 4,
                        requiredYear: '',
                        requiredMonth: '',
                        requiredDocument: 'required'
                        }"
                    ></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="report-claims" *ngIf="templateView==7">
    <div class="row mt-5">
        <div class="col-md-12 col-sm-12">
            <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.REPORT_CLAINS" | translate }}</h2>
        </div>
    </div>
    
    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="form-group row mx-5 my-5  justify-content-md-left">
                <div class="col-md-12">
                    <div class="form-group kt-form__group">
                        <form
                        [formGroup]="filterDateEndForm"
                        (ngSubmit)="submitClaimsFilter(loadingModal)" >
                            <div class="row">
                                <div class="col mb-5">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label class="sr-only">{{ "INPUT.DATEEND" | translate }}</label>
                                            <div class="input-group">
                                                <input class="form-control" formControlName="inputFechaHasta" name="inputFechaHasta" placeholder="" ngbDatepicker #d2="ngbDatepicker" autocomplete="false" 
                                                [ngClass]="{ 'is-invalid': filterDateEndForm.controls['inputFechaHasta'].invalid }"
                                                readonly>
                                                <div class="input-group-append">
                                                <button class="btn btn-primary" (click)="d2.toggle()" type="button">
                                                    <i class="fa fa-calendar"></i>
                                                </button>
                                                </div>
                                            </div>
                                            <ng-container
                                                [ngTemplateOutlet]="formError"
                                                [ngTemplateOutletContext]="{
                                                validation: 'required',
                                                message: 'Campo requerido.',
                                                control: filterDateEndForm.controls['inputFechaHasta']
                                                }"
                                            ></ng-container>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="sr-only">{{ "INPUT.DOCUMENT_TYPE" | translate }}</label>
                                                <select class="form-control" placeholder="" formControlName="inputDocument" name="inputDocument"
                                                [ngClass]="{ 'is-invalid': filterDateEndForm.controls['inputDocument'].invalid }">
                                                    <option value="">{{ "INPUT.DOCUMENT_TYPE" | translate }}</option>
                                                    <option value="1" selected>{{ "INPUT.DOWNLOAD_EXCEL" | translate }}</option>
                                                    <option value="2">{{ "INPUT.DOWNLOAD_PDF" | translate }}</option>
                                                </select>
                                                <ng-container
                                                    [ngTemplateOutlet]="formError"
                                                    [ngTemplateOutletContext]="{
                                                    validation: 'required',
                                                    message: 'Campo requerido.',
                                                    control: filterDateEndForm.controls['inputDocument']
                                                    }"
                                                ></ng-container>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="form-group mb-0 text-right">
                                                <button type="submit" class="btn btn bg-success text-white font-weight-boldest mr-10" >{{ "INPUT.DOWNLOAD" | translate }}</button>
                                                <a href="javascript:void(0)" class="btn btn-default font-weight-boldest" (click)="clickView(1)">{{ "INPUT.CANCEL" | translate }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="report-claims" *ngIf="templateView==8">
    <div class="row mt-5">
        <div class="col-md-12 col-sm-12">
            <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.REPORT_SOLICITUDES" | translate }}</h2>
        </div>
    </div>
    
    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="form-group row mx-5 my-5  justify-content-md-left">
                <div class="col-md-12">
                    <div class="form-group kt-form__group">
                        <form
                        [formGroup]="filterSolicitudesDateEndForm"
                        (ngSubmit)="submitSolicitudesFilter(loadingModal)" >
                            <div class="row">
                                <div class="col mb-5">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label class="sr-only">{{ "INPUT.DATEEND" | translate }}</label>
                                            <div class="input-group">
                                                <input class="form-control" formControlName="inputFechaHasta" name="inputFechaHasta" placeholder="" ngbDatepicker #d2="ngbDatepicker" autocomplete="false" 
                                                [ngClass]="{ 'is-invalid': filterSolicitudesDateEndForm.controls['inputFechaHasta'].invalid }"
                                                readonly>
                                                <div class="input-group-append">
                                                <button class="btn btn-primary" (click)="d2.toggle()" type="button">
                                                    <i class="fa fa-calendar"></i>
                                                </button>
                                                </div>
                                            </div>
                                            <ng-container
                                                [ngTemplateOutlet]="formError"
                                                [ngTemplateOutletContext]="{
                                                validation: 'required',
                                                message: 'Campo requerido.',
                                                control: filterSolicitudesDateEndForm.controls['inputFechaHasta']
                                                }"
                                            ></ng-container>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="sr-only">{{ "INPUT.DOCUMENT_TYPE" | translate }}</label>
                                                <select class="form-control" placeholder="" formControlName="inputDocument" name="inputDocument"
                                                [ngClass]="{ 'is-invalid': filterDateEndForm.controls['inputDocument'].invalid }">
                                                    <option value="">{{ "INPUT.DOCUMENT_TYPE" | translate }}</option>
                                                    <option value="1" selected>{{ "INPUT.DOWNLOAD_EXCEL" | translate }}</option>
                                                    <option value="2">{{ "INPUT.DOWNLOAD_PDF" | translate }}</option>
                                                </select>
                                                <ng-container
                                                    [ngTemplateOutlet]="formError"
                                                    [ngTemplateOutletContext]="{
                                                    validation: 'required',
                                                    message: 'Campo requerido.',
                                                    control: filterDateEndForm.controls['inputDocument']
                                                    }"
                                                ></ng-container>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="form-group mb-0 text-right">
                                                <button type="submit" class="btn btn bg-success text-white font-weight-boldest mr-10" >{{ "INPUT.DOWNLOAD" | translate }}</button>
                                                <a href="javascript:void(0)" class="btn btn-default font-weight-boldest" (click)="clickView(1)">{{ "INPUT.CANCEL" | translate }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div id="report-others" *ngIf="templateView==9">
    <div class="row mt-5">
        <div class="col-md-12 col-sm-12">
            <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "REPORT.REPORT_LIST" | translate }}</h2>
        </div>
    </div>
    
    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="form-group mx-5 justify-content-md-left">
                <form
                [formGroup]="otherReportForm"
                (ngSubmit)="submitOtherReportForm(loadingModal)" >
                    <div class="row my-5">
                        <div class="col-md-3 col-sm-12">
                            <div class="form-group h65">
                                <label class="sr-only">{{ "INPUT.DATESTART" | translate }}</label>
                                <div class="input-group">
                                    <input class="form-control" placeholder='{{ "INPUT.DATESTART" | translate }}' formControlName="inputFechaDesde" name="inputFechaDesde" ngbDatepicker #d1="ngbDatepicker" autocomplete="false" 
                                    [ngClass]="{ 'is-invalid': otherReportForm.controls['inputFechaDesde'].invalid }"
                                    readonly>
                                    <div class="input-group-append">
                                    <button class="btn btn-primary" (click)="d1.toggle()" type="button">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                    </div>
                                </div>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: otherReportForm.controls['inputFechaDesde']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <label class="sr-only">{{ "INPUT.DATEEND" | translate }}</label>
                            <div class="form-group h65">
                                <div class="input-group">
                                    <input class="form-control" placeholder='Fecha Hasta' formControlName="inputFechaHasta" name="inputFechaHasta" ngbDatepicker #d2="ngbDatepicker" autocomplete="false" 
                                    [ngClass]="{ 'is-invalid': otherReportForm.controls['inputFechaHasta'].invalid }"
                                    readonly>
                                    <div class="input-group-append">
                                    <button class="btn btn-primary" (click)="d2.toggle()" type="button">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                    </div>
                                </div>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: otherReportForm.controls['inputFechaHasta']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <div class="form-group h65">
                                <label class="sr-only">{{ "REPORT.REPORT_TYPE" | translate }}</label>
                                <select class="form-control" placeholder="" formControlName="inputTypeReport" name="inputTypeReport"
                                [ngClass]="{ 'is-invalid': otherReportForm.controls['inputTypeReport'].invalid }">
                                    <option value="">{{ "REPORT.REPORT_TYPE" | translate }}</option>
                                    <option *ngFor="let item of tipoReporte | async" value="{{ item.IdTipoDocumento }}" >{{ item.TipoDocumento }}</option>
                                </select>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: otherReportForm.controls['inputTypeReport']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="col-md-3 col-sm-12 ">
                            <div class="form-group h65">
                                <label class="sr-only">{{ "INPUT.DOCUMENT_TYPE" | translate }}</label>
                                <select class="form-control" placeholder="" formControlName="inputDocument" name="inputDocument"
                                [ngClass]="{ 'is-invalid': otherReportForm.controls['inputDocument'].invalid }">
                                <option value="">{{ "INPUT.DOCUMENT_TYPE" | translate }}</option>
                                <option value="1" selected>{{ "INPUT.DOWNLOAD_EXCEL" | translate }}</option>
                                <option value="2">{{ "INPUT.DOWNLOAD_PDF" | translate }}</option>
                                </select>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: otherReportForm.controls['inputDocument']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                    </div>
                    
                    <div class="separator separator-solid separator-border-2 separator-light"></div>

                    <div class="row my-5">
                        <div class="col-md-12">
                            <div class="form-group mb-0 text-right">
                                <button type="submit" class="btn btn bg-success text-white font-weight-boldest mr-2" >{{ "INPUT.DOWNLOAD" | translate }}</button>
                                <a href="javascript:void(0)" class="btn btn-default font-weight-boldest" (click)="clickView(1)">{{ "INPUT.CANCEL" | translate }}</a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div id="report-bi-1" *ngIf="templateView==6" [hidden]="!biM1HTMLShow" >
    <div class="row mt-5">
        <div class="col-md-6 col-sm-12">
            <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{biM1HTML.NombreReporte}}</h2>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                </div>
            </div>
        </div>
    </div>
    
    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <iframe id="report-bi-1-iframe" class="border-0" #report_bi_1_iframe [src]="biM1HTML.ReporteBI | safe" width="{{biM1HTML.ReportWidth}}" height="{{biM1HTML.ReportHeight}}"> 
            </iframe>
        </div>
    </div>
</div>

<div class="loadingModal">
    <ng-template #loadingModal let-c="close" let-d="dismiss">
        <div class="modal-body">
            <div class="loading-totalesModal">
                <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
            </div>
        </div>
    </ng-template>
</div>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template
#genericFilterForm
let-control="control"
let-filter="filter"
let-requiredYear="requiredYear",
let-requiredMonth="requiredMonth",
let-requiredDocument="requiredDocument",
>
<form
    [formGroup]="filterForm"
    (ngSubmit)="submitFilter(loadingModal, filter)" >
        <div class="row">
            <div class="col mb-5">
                <div class="row">
                    <div class="col-md-4" *ngIf="requiredYear=='required'">
                        <div class="form-group">
                            <label class="sr-only">{{ "INPUT.YEAR" | translate }}</label>
                            <select class="form-control" placeholder="" formControlName="inputAnyo" name="inpuAnyo"
                            [ngClass]="{ 'is-invalid': filterForm.controls['inputAnyo'].invalid }">
                                <option value="">{{ "INPUT.YEAR" | translate }}</option>
                                <option *ngFor="let item of anyos | async" value="{{item.IdAno}}">{{item.Ano}}</option>
                            </select>
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: requiredYear,
                                message: 'Campo requerido.',
                                control: filterForm.controls['inputAnyo']
                                }"
                            ></ng-container>
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf="requiredMonth=='required'">
                        <div class="form-group">
                            <label class="sr-only">{{ "INPUT.MONTH" | translate }}</label>
                            <select class="form-control" placeholder="" formControlName="inputMes" name="inputMes"
                             [ngClass]="{ 'is-invalid': filterForm.controls['inputMes'].invalid }">
                                <option value="" selected>{{ "INPUT.MONTH" | translate }}</option>
                                <option *ngFor="let item of meses | async" value="{{item.Mes}}">{{item.Descripcion}}</option>
                            </select>
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: requiredMonth,
                                message: 'Campo requerido.',
                                control: filterForm.controls['inputMes']
                                }"
                            ></ng-container>
                        </div>
                    </div>
                    
                    <div class="col-md-4" *ngIf="requiredDocument=='required'">
                        <div class="form-group">
                            <label class="sr-only">{{ "INPUT.DOCUMENT_TYPE" | translate }}</label>
                            <select class="form-control" placeholder="" formControlName="inputDocument" name="inputDocument"
                            [ngClass]="{ 'is-invalid': filterForm.controls['inputDocument'].invalid }">
                                <option value="">{{ "INPUT.DOCUMENT_TYPE" | translate }}</option>
                                <option value="1" selected>{{ "INPUT.DOWNLOAD_EXCEL" | translate }}</option>
                                <option value="2">{{ "INPUT.DOWNLOAD_PDF" | translate }}</option>
                            </select>
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: requiredDocument,
                                message: 'Campo requerido.',
                                control: filterForm.controls['inputDocument']
                                }"
                            ></ng-container>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-4">
                <div class="form-group mb-0 text-right">
                    <button type="submit" class="btn btn bg-success text-white font-weight-boldest mr-10" >{{ "INPUT.DOWNLOAD" | translate }}</button>
                    <a href="javascript:void(0)" class="btn btn-default font-weight-boldest" (click)="clickView(1)">{{ "INPUT.CANCEL" | translate }}</a>
                </div>
            </div>
        </div>
    </form>
</ng-template>
